import React, { useState } from "react";
import { useDispatch } from "react-redux";
import * as ReactBootstrap from "react-bootstrap";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";

import CreateTrader from "../../components/Trademate/CreateTrader";
import Title from "../ReusableComponents/title";
import CombinedPopup from "../../components/Popups/CombinedPopup";

import { fetchTraderJournalCreate } from "../../store/reducers/trademateReducer";
import "../../assets/css/accountmetrics.scss";
import caret from "../../assets/images/charm_tick.svg";
import line from "../../assets/images/Line.svg";
import { dollarUS, formatDate } from "../../utilities/formatters";

const ActionFormatter = (data) => {
  const action = data.toLowerCase();
  const classlist =
    action === "sell" ? "Negative" : action === "buy" ? "Positive" : "Action";

  return <div className={`TJAction ${classlist}`}>{data}</div>;
};

// const NumberFormatter = (num) => {
//   let data = parseInt(num);
//   const classlist = data < 0 ? "Negative" : data >= 0 ? "Positive" : "Number";

//   return <div className={classlist}>{num}</div>;
// };

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  background: "#161d26",
  width: "80%",
  height: "90vh",
  overflowY: "scroll",
  padding: "0",
  borderRadius: "20px",
};

const TradingJournal = ({ platform="mt5", TradingHistory }) => {
  const dispatch = useDispatch();

  const [List, setList] = useState([]);
  const [ListEntry, setListEntry] = useState([]);
  const [ListAll, setListAll] = useState(true);
  const [showDrop, setShowDrop] = useState(false);
  const [showDropEntry, setshowDropEntry] = useState(false);
  const [tickIn, setTickIn] = useState(false);
  const [tickOut, setTickOut] = useState(false);
  // const handleChangeDrop = (e) => {
  //   setShowDrop(!showDrop);
  // };

  // MODAL States
  const [open, setOpen] = React.useState(false);
  const [modalPrefetchData, setModalPrefetchData] = useState(false);
  const handleOpen = (order) => {
    const trade = TradingHistory.filter((trade) => trade.order === order);
    setModalPrefetchData(trade.length && trade[0]);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  // POPUP States
  const [Show, setShow] = useState(false);
  const [CombinedPUHead, setCombinedPUHead] = useState("");
  const [SPopup, setSPopup] = useState(false);
  const [CombinedPUBody, setCombinedPUBody] = useState("");
  const [PopUpType, setPopUpType] = useState("");

  const handlePopupCross = () => {
    setPopUpType(false);
    setShowPopup(false);
    setCombinedPUHead(false);
    setCombinedPUBody(false);
  };

  const [tickBuy, setTickBuy] = useState(false);
  const handleChangeCheckBuy = (e) => {
    setListEntry("");
    setListAll(false);
    setTickBuy(!tickBuy);
    let var1 = e.currentTarget.textContent;
    setList((oldArray) => [...oldArray, var1]);
    if (tickBuy) {
      setList((oldArray) => oldArray.filter((item) => item !== var1));
    }
  };
  const [tickSell, setTickSell] = useState(false);
  const handleChangeCheckSell = (e) => {
    setListEntry("");
    setListAll(false);
    setTickSell(!tickSell);
    let var2 = e.currentTarget.textContent;
    setList((oldArray) => [...oldArray, var2]);
    if (tickSell) {
      setList((oldArray) => oldArray.filter((item) => item !== var2));
    }
  };
  const [tickWithdrawal, setTickWithdrawal] = useState(false);
  const handleChangeCheckWithdrawal = (e) => {
    setListEntry("");
    setListAll(false);
    setTickWithdrawal(!tickWithdrawal);
    let var3 = e.currentTarget.textContent;
    setList((oldArray) => [...oldArray, var3]);
    if (tickWithdrawal) {
      setList((oldArray) => oldArray.filter((item) => item !== var3));
    }
  };
  const [tickDeposite, setTickDeposite] = useState(false);
  const handleChangeCheckDeposite = (e) => {
    setListEntry("");
    setListAll(false);
    setTickDeposite(!tickDeposite);
    let var4 = e.currentTarget.textContent;
    setList((oldArray) => [...oldArray, var4]);
    if (tickDeposite) {
      setList((oldArray) => oldArray.filter((item) => item !== var4));
    }
  };
  const [tickInterest, setTickInterest] = useState(false);
  const handleChangeCheckInterest = (e) => {
    setListEntry("");
    setListAll(false);
    setTickInterest(!tickInterest);
    let var5 = e.currentTarget.textContent;
    setList((oldArray) => [...oldArray, var5]);
    if (tickInterest) {
      setListAll(false);
      setList((oldArray) => oldArray.filter((item) => item !== var5));
    }
  };

  const handleChangeCheckIn = (e) => {
    setListAll(false);
    setTickIn(!tickIn);
    let var7 = e.currentTarget.textContent;
    setListEntry((oldArray) => [...oldArray, var7]);
    if (tickIn) {
      setListAll(false);
      setListEntry((oldArray) => oldArray.filter((item) => item !== var7));
    }
  };

  const handleChangeCheckOut = (e) => {
    setListAll(false);
    setTickOut(!tickOut);
    let var6 = e.currentTarget.textContent;
    setListEntry((oldArray) => [...oldArray, var6]);
    if (tickOut) {
      setListEntry((oldArray) => oldArray.filter((item) => item !== var6));
    }
  };

  const [showPopup, setShowPopup] = useState(false);
  const handlePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleFormSubmit = (Data) => {
    console.log(Data, "data");
    dispatch(fetchTraderJournalCreate(Data))
      .then((res) => {
        if (res) {
          // SUCCESS
          setSPopup(true);
          setCombinedPUHead("Success");
          setCombinedPUBody("Journal created!");
          setPopUpType("success");
          setOpen(false);
        }
      })
      .catch((error) => {
        alert("Error");
      });
  };

  // const renderTradingJournal = (tradingjournal, index) => {
  //   if (List.includes(tradingjournal.direction) || ListAll === true) {
  //     return (
  //       <tr key={index}>
  //         <td>56</td>
  //         <td>12th jan</td>
  //         <td>12th jan</td>
  //         <td>{tradingjournal.symbol}</td>
  //         <td>{ActionFormatter(tradingjournal.action)}</td>
  //         <td>{tradingjournal.order}</td>
  //         <td>{tradingjournal.stopLoss}</td>
  //         <td>{tradingjournal.takeProfit}</td>
  //         <td>{tradingjournal.entryPrice}</td>
  //         <td>{tradingjournal.exitPrice}</td>
  //         <td>1000</td>
  //         <td>1000</td>
  //         <td>{0 || tradingjournal.profit.toFixed(2)}</td>
  //         <td>1000</td>
  //         <td className="TableChart">1000</td>

  //         {/* <td>{tradingjournal.orderNumber}</td>
  //         <td>{tradingjournal.openTime}</td>
  //         <td>{tradingjournal.closeTime}</td>
  //         <td>{tradingjournal.symbol}</td>
  //         <td>{ActionFormatter(tradingjournal.direction)}</td>
  //         <td>{tradingjournal.orderSize}</td>
  //         <td>{tradingjournal.slPrice}</td>
  //         <td>{tradingjournal.tpPrice}</td>
  //         <td>{tradingjournal.entryPrice}</td>
  //         <td>{tradingjournal.exitPrice}</td>
  //         <td>{0 || NumberFormatter(tradingjournal.pips)}</td>
  //         <td>{NumberFormatter(tradingjournal.profit)}</td>
  //         <td>{0 || tradingjournal.tradeDurationInMinutes.toFixed(2)}</td>
  //         <td>{0 || tradingjournal.gain}</td>
  //         <td className="TableChart">{0 || tradingjournal.chart}</td> */}
  //       </tr>
  //     );
  //   }
  // };

  return (
    <div className="TradingJournalContainer Container-p-20">
      <CombinedPopup
        type={PopUpType}
        trigger={SPopup}
        setTrigger={setSPopup}
        head={CombinedPUHead}
        subhead={CombinedPUBody}
        setShow={setShow}
        onClick={handlePopupCross}
      />
      <div className="TradingJournalBox">
        <div style={{ color: "white" }}>{}</div>
        <div className="d-flex justify-content-between">
          <h1 className="mbb-10 Section-Head">Trading Activity</h1>
          <div className="Link" style={{ cursor: "pointer" }}>
            <Title six>
              <span onClick={handlePopup}>...</span>
            </Title>
            <div>
              {showPopup === true ? (
                <div className="TablePopup">
                  <Title seven>SL/TP Format</Title>
                  <div className="mbb-10">
                    <div
                      className="DropName"
                      onClick={() => setShowDrop(!showDrop)}
                    >
                      <div>Profit</div>
                      <div>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.47473 6.22489C7.71881 5.98081 8.11454 5.98081 8.35861 6.22489L11.6919 9.55822C11.936 9.8023 11.936 10.198 11.6919 10.4421L8.35861 13.7754C8.11454 14.0195 7.71881 14.0195 7.47473 13.7754C7.23065 13.5314 7.23065 13.1356 7.47473 12.8916L10.3661 10.0002L7.47473 7.10877C7.23065 6.86469 7.23065 6.46896 7.47473 6.22489Z"
                            fill="#04D9FF"
                          />
                        </svg>
                      </div>
                    </div>
                    {showDrop === true ? (
                      <div className="mtt-10">
                        <div onClick={handleChangeCheckBuy} className="DropOpt">
                          <Title four>Buy</Title>
                          <div>
                            {tickBuy === true ? <img src={caret} alt="" /> : ""}
                          </div>
                        </div>
                        <img src={line} alt="" />
                        <div
                          onClick={handleChangeCheckSell}
                          className="DropOpt"
                        >
                          <Title four>Sell</Title>
                          <div>
                            {tickSell === true ? (
                              <img src={caret} alt="" />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <img src={line} alt="" />
                        <div
                          onClick={handleChangeCheckWithdrawal}
                          className="DropOpt"
                        >
                          <Title four>Withdrawal</Title>
                          <div>
                            {tickWithdrawal === true ? (
                              <img src={caret} alt="" />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <img src={line} alt="" />
                        <div
                          onClick={handleChangeCheckDeposite}
                          className="DropOpt"
                        >
                          <Title four>Deposite</Title>
                          <div>
                            {tickDeposite === true ? (
                              <img src={caret} alt="" />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <img src={line} alt="" />
                        <div
                          onClick={handleChangeCheckInterest}
                          className="DropOpt"
                        >
                          <Title four>Interest</Title>
                          <div>
                            {tickInterest === true ? (
                              <img src={caret} alt="" />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div>
                    <div
                      className="DropName"
                      onClick={() => setshowDropEntry(!showDropEntry)}
                    >
                      <div>Entry</div>
                      <div>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.47473 6.22489C7.71881 5.98081 8.11454 5.98081 8.35861 6.22489L11.6919 9.55822C11.936 9.8023 11.936 10.198 11.6919 10.4421L8.35861 13.7754C8.11454 14.0195 7.71881 14.0195 7.47473 13.7754C7.23065 13.5314 7.23065 13.1356 7.47473 12.8916L10.3661 10.0002L7.47473 7.10877C7.23065 6.86469 7.23065 6.46896 7.47473 6.22489Z"
                            fill="#04D9FF"
                          />
                        </svg>
                      </div>
                    </div>
                    {showDropEntry === true ? (
                      <div className="mtt-10">
                        <div onClick={handleChangeCheckIn} className="DropOpt">
                          <Title four>In</Title>
                          <div>
                            {tickIn === true ? <img src={caret} alt="" /> : ""}
                          </div>
                        </div>
                        <img src={line} alt="" />
                        <div onClick={handleChangeCheckOut} className="DropOpt">
                          <Title four>Out</Title>
                          <div>
                            {tickOut === true ? <img src={caret} alt="" /> : ""}
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <ReactBootstrap.Table className="hiiii">
          <thead>
          {platform === "mt5" ? (
              <tr>
                <th>Id</th>
                <th>Symbol</th>
                <th>Action</th>
                <th>Entry</th>
                <th>Lots</th>
                <th>Date</th>
                <th>Price</th>
                <th>SL(pips)</th>
                <th>TP(pips)</th>
                <th>Profit</th>
                <th>Action</th>
              </tr>
            ) : (
              <tr>
                <th>Id</th>
                <th>Symbol</th>
                <th>Action</th>
                {/* <th>Entry</th> */}
                <th>Lots</th>
                <th>Date</th>
                <th>Price</th>
                {/* <th>SL(pips)</th> */}
                {/* <th>TP(pips)</th> */}
                <th>Profit</th>
                <th>Action</th>
              </tr>
            )}
          </thead>
          <tbody>
            {TradingHistory && 
              Object.keys(TradingHistory).map((data, index) => {
                if (TradingHistory[data].action === "Balance") return false;
                if (platform === "mt5" &&
                  (List.includes(TradingHistory[data].action) ||
                    ListEntry.includes(TradingHistory[data].entry) ||
                    ListAll === true) &&
                  TradingHistory &&
                  TradingHistory[data]
                ) {
                  return (
                    <tr key={index}>
                      <td>{TradingHistory[data].order}</td>
                      {/* <td>12th jan</td>
                      <td>12th jan</td> */}
                      <td>{TradingHistory[data].symbol}</td>
                      <td>{ActionFormatter(TradingHistory[data].action)}</td>
                      <td>{TradingHistory[data].entry}</td>
                      <td>{TradingHistory[data].volume}</td>
                      <td>{formatDate(TradingHistory[data].date)}</td>
                      <td>{TradingHistory[data].price}</td>
                      <td>{TradingHistory[data].stopLoss}</td>
                      <td>{TradingHistory[data].takeProfit}</td>
                      {/* <td>{TradingHistory[data].entryPrice}</td>
                      <td>{TradingHistory[data].exitPrice}</td>
                      <td>1000</td> */}
                      <td>
                        <p
                          style={{
                            color:
                              (TradingHistory[data].profit < 0 && "#FD504F") ||
                              (TradingHistory[data].profit > 0 && "#0CCE6B"),
                          }}
                        >
                          {TradingHistory[data].profit}
                        </p>
                      </td>
                      <td>
                        <Button
                          onClick={(e) =>
                            handleOpen(TradingHistory[data].order)
                          }
                        >
                          Create Journal
                        </Button>
                      </td>
                      {/* <td>67</td>
                      <td>1000</td>
                      <td className="TableChart">1000</td> */}
                    </tr>
                  );
                } else if (
                  platform === "ctrader" &&
                  (List.includes(TradingHistory[data].action) ||
                    ListEntry.includes(TradingHistory[data].entry) ||
                    ListAll === true) &&
                  TradingHistory &&
                  TradingHistory[data]
                ) {
                  return (
                    <tr key={index}>
                      <td>{TradingHistory[data].position}</td>
                      <td>{TradingHistory[data].symbol}</td>
                      <td>{ActionFormatter(TradingHistory[data].trade_side)}</td>
                      <td>{TradingHistory[data].volume}</td>
                      <td>{formatDate(TradingHistory[data].date)}</td>
                      <td>{(TradingHistory[data].price)}</td>
                      <td>{Number(TradingHistory[data].profit).toFixed(4)}</td>
                      <td>
                        <Button
                          onClick={(e) =>
                            handleOpen(TradingHistory[data].positionId)
                          }
                        >
                          Create Journal
                        </Button>
                      </td>
                    </tr>
                  );
                }
                return false;
              })}
          </tbody>
        </ReactBootstrap.Table>


        <Modal
        
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <CreateTrader
                handleFormSubmit={handleFormSubmit}
                handleCross={handleClose}
                prefetchData={modalPrefetchData}
              />
            </Box>
          </Fade>
        </Modal>
        <div />
      </div>
    </div>
  );
};

export default TradingJournal;
